
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-home-panel-2",
      function () {
        return require("private-next-pages/smart-home-panel-2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-home-panel-2"])
      });
    }
  